@file:Suppress("TooGenericExceptionCaught")

package com.nonopn.skydome.common.app.pages.documents

import com.nonopn.dispatchers.DefaultDispatcher
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryItem
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skywatcher.app.utils.safeLaunch
import eu.codlab.viewmodel.StateViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.async

data class DocumentsState(
    val isLoading: Boolean = true,
    val projects: List<Project> = emptyList(),
    val history: List<DocumentHistoryItem> = emptyList(),
    // False until the local cache of the history has been read
    val isHistoryReady: Boolean = false,
    val error: String? = null,
)

class DocumentsModel(
    private val appModel: AppModel,
) : StateViewModel<DocumentsState>(DocumentsState()) {
    private val backgroundScope = CoroutineScope(DefaultDispatcher + SupervisorJob())

    init {
        load()
    }

    fun load() = safeLaunch {
        backgroundScope.async {
            // The local cache is displayed immediately, the server history replaces it once synchronized
            val local = appModel.getSpecificData()?.documentHistory.orEmpty()
            updateState { copy(isLoading = true, error = null, history = local, isHistoryReady = true) }
            try {
                val api = appModel.states.value.currentApi
                val projects = api?.estimatesData()?.map { it.project }.orEmpty()
                updateState { copy(isLoading = false, projects = projects, error = null) }
            } catch (e: Exception) {
                e.printStackTrace()
                updateState { copy(isLoading = false, error = e.message) }
            }

            // Offline or server error: stay on the local history without any error
            appModel.syncDocumentHistory(local)?.let { synced ->
                updateState { copy(history = synced) }
            }
        }
    }
}
